export default "skymp5-front/02ccdc972f1476591ae05c6efb701c60.png";